export default "__VITE_ASSET__DLUlgCoC__"